import styled from 'styled-components';

export const UserRedirect = styled.div.attrs({
    className: 'user-redirect',
})`
    width: 100%;
`;
